import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { WORKSPACE_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import { TransferRequest, TransferResponse } from './types';

export function useTransferMutationApi() {
  const workspaceId = useWorkspace()?.id;

  return useBaseMutation<TransferRequest, TransferResponse>({
    url: `${WORKSPACE_ROOT_ENDPOINT}/${workspaceId}/transfers`,
    method: HttpMethod.post,
  });
}
